export default {
   "memberid": "",
   "lpbmcode": "",
   "lpbmno": "",
   "membertype": "",
   "memberstatus": "",
   "dateapplied": "",
   "dateapproved": "",
   "datepayment": "",
   "datevalid": "",
}
